<template>
  <div :cssClass="type" class="message">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Message',
  props: {
    type: {
      type: String,
      required: false,
      default: 'primary'
    }
  }
}
</script>

<style lang="less" scoped>
  .message {
    margin-bottom: 25px;
  }
</style>
